import { SignatureBox } from '@models/Process-Approval/SignatureBox';
import { Address } from '@models/Address/Address';
import { UserCertificateDto } from '@models/SignType/UserCertificateDto';
import { TenantProfileEnum } from '@models/Enum/TenantProfileEnum';
import { PrivacyStatus } from '@models/User/PrivacyStatus';
import { UiSettings } from '@models/User/UiSettings';

export class UserData {
  constructor(
    public username: string,
    public password: string,
    public name: string,
    public surname: string,
    public denomination: string,
    public mail: string,
    public phone: string,
    public roles: Role[],
    public internal: boolean,
    public companyName: string,
    public tenant: string,
    public tenantProfile: TenantProfileEnum,
    public tenantActivationDate: Date,
    public language: string,
    public mobilePhone: string,
    public notificaMail: boolean,
    public otp: boolean,
    public pec: string,
    public signType: string[],
    public views: string[],
    public walletPin: boolean,
    public logo: string[],
    public hasQualifiedCertificate: boolean,
    public hasNotQualifiedCertificate: boolean,
    public hasFeaOtpCertified: boolean,
    public privacyStatus: PrivacyStatus,
    public reminderSign: boolean,
    public reminderDocExpire: boolean,
    public notifyDepSigned: boolean,
    public notifyRefuseAndFinal: boolean,
    public notifySignerWhenDelegateSign : boolean,
    public notifyAddAttachment : boolean,
    public notifyRegistryCertified : boolean,
    public uiSettings: UiSettings,
    public tenantExternal: string,
    public ciphered: boolean,
    public certificates: UserCertificateDto[] = [],
    public canImpersonateHeader : boolean,
    public basket: number,
    public invoiceRegistry: Address,
    public operativeRegistry: Address,
    public legalRegistry: Address,
    public processRoleKey: string,
  ) {}
}

export enum Role {
  BASIC = 'basic',
  ADVANCED = 'advanced',
  GUEST = 'guest',
  ADMIN = 'admin',
}
